import Autocomplete from '../admin/components/autocomplete';
import { getWebsiteIdFromPath } from '../admin/util/websiteIdExtractor';

function bindKvKAutocompleteHandler(form) {
    if (form === null || form.dataset.bound === 'true') {
        return;
    }

    const siteId = getWebsiteIdFromPath();
    const kvkNumberField = form.querySelector('[data-kvk-number]');
    const kvkProviderField = form.querySelector('[data-kvk-provider]');
    const kvkCompanyNameField = form.querySelector('[data-kvk-company-name]');
    const kvkCompanyTypeField = form.querySelector('[data-kvk-company-type]');
    const kvkFoundingDateField = form.querySelector('[data-kvk-founding-date]');
    const kvkStreetField = form.querySelector('[data-kvk-street]');
    const kvkHouseNumberField = form.querySelector('[data-kvk-house-number]');
    const kvkHouseNumberAdditionField = form.querySelector('[data-kvk-house-number-addition]');
    const kvkPostalCodeField = form.querySelector('[data-kvk-postal-code]');
    const kvkCityField = form.querySelector('[data-kvk-city]');
    const kvkCountryField = form.querySelector('[data-kvk-country]');

    const setIfExists = (field, value) => {
        if (field === null || value === null || value === undefined) {
            return;
        }

        field.value = value;
        field.dispatchEvent(new Event('change'));
    };

    function autofill() {
        const kvkProvider = kvkProviderField?.value || 'nl.kvk';

        fetch(`/${siteId}/kvk/api/search/${kvkProvider}/${kvkNumberField.value}`)
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => {
                if (data === null) {
                    return;
                }

                setIfExists(kvkCompanyNameField, data.companyName);
                setIfExists(kvkCompanyTypeField, data.companyType);
                setIfExists(kvkFoundingDateField, data.foundingDate ? new Date(data.foundingDate).toISOString().slice(0, 10) : null);
                setIfExists(kvkStreetField, data.address?.street);
                setIfExists(kvkHouseNumberField, data.address?.houseNumber);
                setIfExists(kvkHouseNumberAdditionField, data.address?.houseNumberAddition);
                setIfExists(kvkPostalCodeField, data.address?.postalCode);
                setIfExists(kvkCityField, data.address?.city);
                setIfExists(kvkCountryField, data.address?.country.code);
            });
    }

    kvkNumberField.addEventListener('blur', () => {
        if (kvkNumberField.value.match(/^\d{7,8}$/) && kvkCompanyNameField.value === '') {
            autofill();
        }
    });

    const autocomplete = new Autocomplete();
    const autocompleteSuggestionsContainer = autocomplete.createContainer();
    autocompleteSuggestionsContainer.classList.add('absolute', 'z-10', 'mt-6');

    const existingAutocompleteSuggestionContainer = kvkCompanyNameField.parentNode.querySelector('[data-bound="false"]');

    if (existingAutocompleteSuggestionContainer) {
        existingAutocompleteSuggestionContainer.remove();
    }

    kvkCompanyNameField.parentNode.appendChild(autocompleteSuggestionsContainer);
    let autocompleteRequestTimer = null;

    const appendAutocompleteContainer = (e) => {
        const value = kvkCompanyNameField.value;

        if (value.length < 3 || value.value === '') {
            return;
        }

        if (autocompleteRequestTimer) {
            clearTimeout(autocompleteRequestTimer);
        }

        autocompleteRequestTimer = setTimeout(() => {
            fetch(`/${siteId}/kvk/api/autocomplete/${value}`)
                .then((response) => (response.ok ? response.json() : null))
                .then((data) => {
                    if (data === null) {
                        return;
                    }

                    const suggestions = [];

                    for (const key in data) {
                        const city = document.createElement('small');
                        city.classList.add('block');
                        city.innerText = `${data[key].street}, ${data[key].city}`;

                        const element = autocomplete.createElement(`${data[key].name}`);
                        element.appendChild(city);

                        element.addEventListener('click', () => {
                            const parts = key.split('::');
                            if (parts.length !== 2) {
                                console.warn('invalid response');
                            }
                            kvkNumberField.value = parts[1];

                            if (kvkProviderField !== null) {
                                kvkProviderField.value = parts[0];
                            }

                            autofill();

                            autocompleteSuggestionsContainer.hidden = true;
                        });

                        suggestions.push(element);
                    }

                    autocompleteSuggestionsContainer.replaceChildren(...suggestions);
                    autocompleteSuggestionsContainer.hidden = suggestions.length <= 0;
                });
        }, 500);
    };

    const nameSeachButton = form.querySelector('[data-kvk-name-search-button]');

    if (nameSeachButton) {
        nameSeachButton.hidden = false;
        nameSeachButton.addEventListener('click', (e) => {
            e.preventDefault();
            appendAutocompleteContainer();
        });
    }

    const numberSearchButton = form.querySelector('[data-kvk-number-search-button]');

    if (numberSearchButton) {
        numberSearchButton.hidden = false;
        numberSearchButton.addEventListener('click', (e) => {
            e.preventDefault();
            autofill();
        });
    }

    kvkCompanyNameField.addEventListener('input', appendAutocompleteContainer);
    form.dataset.bound = 'true';
}

function initialize(root) {
    for (const form of root.querySelectorAll('[data-kvk-api]')) {
        bindKvKAutocompleteHandler(form);
    }
}

document.addEventListener('click', (event) => {
    bindKvKAutocompleteHandler(event.target.closest('[data-kvk-api]'));
});

window.addEventListener('AutoWise.Admin.ModalContentUpdated', (event) => {
    const modal = event.detail.modal;

    if (!(modal instanceof HTMLDialogElement)) {
        throw new Error('Modal is not an instance of HTMLDialogElement');
    }

    initialize(modal);
});

initialize(document);
